import { computed } from 'vue'
import { useSidebarStore } from '@/stores/useSidebarStore'

export function useSidebarIsOpen(id: string, defaultValue = false) {
  const store = useSidebarStore()
  store.register(id, defaultValue)

  return computed({
    get: () => store.isOpen(id),
    set: (val: boolean) => {
      if (val) store.open(id)
      else store.close(id)
    }
  })
}
